import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CalendarView } from 'angular-calendar';

@Component({
  selector: 'mwl-demo-utils-calendar-header',
  template: `
    <div class="row text-center">
      <div class="col-md-4">      

        <div class="btn" mwlCalendarPreviousView [view]="view" [(viewDate)]="viewDate" (viewDateChange)="viewDateChange.next(viewDate)">      
          <button style="background-color: #343a40; color:white; width:50px; height:40px; border-radius:10px;" class="mat-elevation-z2" mat-button ><i class="fa fa-arrow-left"></i></button>      
        </div>

        <div class="btn btn-outline-secondary mat-elevation-z2 " mwlCalendarToday [(viewDate)]="viewDate"  (viewDateChange)="viewDateChange.next(viewDate)">
          HOY
        </div>
        <div class="btn" mwlCalendarNextView [view]="view" [(viewDate)]="viewDate"  (viewDateChange)="viewDateChange.next(viewDate)">
          <button style="background-color: #343a40; color:white; width:50px; height:40px; border-radius:10px;" class="mat-elevation-z2" mat-button ><i class="fa fa-arrow-right"></i></button> 
        </div>      
       
      </div>

      <div class="col-md-4" style="display:flex; justify-content:center; aling-items:center;">
        <h3>{{ viewDate | calendarDate: view + 'ViewTitle':locale }}</h3>
      </div>

      <div class="col-md-4">        

        <div class="btn" (click)="viewChange.emit(CalendarView.Month)" [class.active]="view === CalendarView.Month">
         <button  class="mat-elevation-z2" mat-raised-button style="background-color: #343a40; color:white; width:50px; height:40px; border-radius:10px;">MES</button>
        </div>
        <div class="btn" (click)="viewChange.emit(CalendarView.Week)" [class.active]="view === CalendarView.Week" style="padding: 0;">
         <button  class="mat-elevation-z2" mat-raised-button style="background-color: #343a40; color:white;  width:80px; height:40px; border-radius:10px;">SEMANA</button>
        </div>
        <div class="btn" (click)="viewChange.emit(CalendarView.Day)" [class.active]="view === CalendarView.Day">
         <button  class="mat-elevation-z2" mat-raised-button style="background-color: #343a40; color:white;  width:50px; height:40px; border-radius:10px;">DIA</button>
        </div>

      </div>
    

    </div>
    <br />
  `,
})
export class CalendarHeaderComponent {
  @Input() view: CalendarView;
  @Input() viewDate: Date;
  @Input() locale: string = 'es';
  @Output() viewChange = new EventEmitter<CalendarView>();
  @Output() viewDateChange = new EventEmitter<Date>();
  CalendarView = CalendarView;
}
